export const ADJUST_SUM_INSURED_FLOW_ADJUST_VALUE =
  "ADJUST_SUM_INSURED_FLOW_ADJUST_VALUE";
export const ADJUST_SUM_INSURED_FLOW_REVIEW_AND_CONFIRM =
  "ADJUST_SUM_INSURED_FLOW_REVIEW_AND_CONFIRM";
export const ADJUST_SUM_INSURED_FLOW = "ADJUST_SUM_INSURED_FLOW";
